import { useEffect } from 'react';
import { applyCssDeclarations } from '@utils/css';
import { tokens } from './atom.bullet.style.js';

function useBulletScale(ref, listRef, extraDeps = []) {
  useEffect(() => {
    const bullet = ref.current;
    const list = listRef.current;
    if (!bullet || !list) {
      return;
    }
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      if (!entry) {
        return;
      }
      applyCssDeclarations(tokens.__override({
        scale: entry.intersectionRatio,
        origin: entry.intersectionRect.left === entry.rootBounds?.left ? "right" : entry.intersectionRect.right === entry.rootBounds?.right ? "left" : undefined
      }), bullet);
    }, {
      root: list,
      threshold: new Array(100).fill(undefined).map((_, index) => index / 100),
      rootMargin: "0px -10px"
    });
    setTimeout(() => {
      observer.observe(bullet);
    });
    return () => {
      observer.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listRef, ref, ...extraDeps]);
}

export { useBulletScale };
//# sourceMappingURL=hook.bullet-scale.js.map
